import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import consola from 'consola';
import productQuery from '~/graphql/product.gql';
import productVariantsQuery from '~/graphql/product/variants.gql';
import productImagesQuery from '~/graphql/product/images.gql';
import productsQuery from '~/graphql/products.gql';
import productCarouselsQuery from '~/graphql/product/carousels.gql';
import productOffersQuery from '~/graphql/product/offers.gql';

function fetchProductCarousels(_x, _x2) {
  return _fetchProductCarousels.apply(this, arguments);
}

function _fetchProductCarousels() {
  _fetchProductCarousels = _asyncToGenerator(function* (context, reference) {
    let profileId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    let exclude = arguments.length > 3 ? arguments[3] : undefined;
    let useLatest = arguments.length > 4 ? arguments[4] : undefined;
    const locale = context.state.i18n.currentLocale.iso;

    try {
      const {
        data
      } = yield context.app.apolloProvider.defaultClient.query({
        query: productCarouselsQuery,
        variables: {
          profileId,
          reference,
          locale,
          exclude,
          useLatest
        }
      });
      return data.product;
    } catch (e) {
      consola.error(e);
      return null;
    }
  });
  return _fetchProductCarousels.apply(this, arguments);
}

function fetchProduct(_x3, _x4, _x5) {
  return _fetchProduct.apply(this, arguments);
}

function _fetchProduct() {
  _fetchProduct = _asyncToGenerator(function* (context, reference, offer) {
    let profileId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    let useLatest = arguments.length > 4 ? arguments[4] : undefined;
    const locale = context.state.i18n.currentLocale.iso;

    try {
      const {
        data
      } = yield context.app.apolloProvider.defaultClient.query({
        query: productQuery,
        variables: {
          locale,
          reference,
          offer,
          profileId,
          useLatest
        }
      });
      return data.product;
    } catch (e) {
      consola.error(e);
      return null;
    }
  });
  return _fetchProduct.apply(this, arguments);
}

function fetchProductVariants(_x6, _x7) {
  return _fetchProductVariants.apply(this, arguments);
}

function _fetchProductVariants() {
  _fetchProductVariants = _asyncToGenerator(function* (_ref, reference) {
    let {
      app,
      getters
    } = _ref;
    const locale = getters['i18n/locale'].iso;

    try {
      const {
        data
      } = yield app.apolloProvider.defaultClient.query({
        query: productVariantsQuery,
        variables: {
          reference,
          locale
        }
      });
      return data.product;
    } catch (e) {
      consola.error(e);
      return null;
    }
  });
  return _fetchProductVariants.apply(this, arguments);
}

function fetchProductImages(_x8, _x9) {
  return _fetchProductImages.apply(this, arguments);
}

function _fetchProductImages() {
  _fetchProductImages = _asyncToGenerator(function* (_ref2, reference) {
    let {
      app,
      getters
    } = _ref2;
    const locale = getters['i18n/locale'].iso;

    try {
      const {
        data
      } = yield app.apolloProvider.defaultClient.query({
        query: productImagesQuery,
        variables: {
          reference,
          locale
        }
      });
      return data.product;
    } catch (e) {
      consola.error(e);
      return null;
    }
  });
  return _fetchProductImages.apply(this, arguments);
}

function fetchProducts(_x10, _x11) {
  return _fetchProducts.apply(this, arguments);
}

function _fetchProducts() {
  _fetchProducts = _asyncToGenerator(function* (_ref3, references) {
    let {
      app,
      getters
    } = _ref3;
    const locale = getters['i18n/locale'].iso;

    try {
      const {
        data
      } = yield app.apolloProvider.defaultClient.query({
        query: productsQuery,
        variables: {
          locale,
          references
        }
      });
      return data.products;
    } catch (e) {
      consola.error(e);
      return null;
    }
  });
  return _fetchProducts.apply(this, arguments);
}

function fetchProductOffers(_x12, _x13, _x14) {
  return _fetchProductOffers.apply(this, arguments);
}

function _fetchProductOffers() {
  _fetchProductOffers = _asyncToGenerator(function* (_ref4, reference, useLatest) {
    let {
      app,
      getters
    } = _ref4;
    const locale = getters['i18n/locale'].iso;

    try {
      const {
        data
      } = yield app.apolloProvider.defaultClient.query({
        query: productOffersQuery,
        variables: {
          reference,
          locale,
          useLatest
        }
      });
      return data.product;
    } catch (e) {
      consola.error(e);
      return null;
    }
  });
  return _fetchProductOffers.apply(this, arguments);
}

export { fetchProduct, fetchProductCarousels, fetchProductVariants, fetchProductImages, fetchProductOffers, fetchProducts };